import { CALL_API } from '../../middleware/api';
import { TRANSFORM } from '../../middleware/transform';
import * as ActionTypes from '../lines';
import * as TimeFilter from '../../constants/TimeFilter';
import { siteType } from '../../constants/configMap';
function fetchLineHeaders(data) {
    var _a;
    var languageId = data.languageId;
    return _a = {
            type: ActionTypes.FETCH_LINE_HEADERS
        },
        _a[CALL_API] = {
            endpoint: "/api/event/lines?languageId=".concat(languageId),
            method: 'get',
            types: [
                ActionTypes.SUCCESS_FETCH_LINE_HEADERS,
                ActionTypes.FAILURE_FETCH_LINE_HEADERS
            ],
            data: data
        },
        _a[TRANSFORM] = {
            section: 'preMatch',
            transformType: 'init',
            provider: function (data) { return data; }
        },
        _a;
}
export function getLineHeaders(data) {
    return function (dispatch) {
        return dispatch(fetchLineHeaders(data));
    };
}
function fetchSportLineHeaders(data) {
    var _a;
    var sportId = data.sportId, languageId = data.languageId, filterType = data.filterType;
    var _b = getFilterDateRange(filterType), startDate = _b.startDate, endDate = _b.endDate;
    return _a = {
            type: ActionTypes.FETCH_SPORT_LINE_HEADERS
        },
        _a[CALL_API] = {
            endpoint: "/api/event/lines?languageId=".concat(languageId, "&sportId=").concat(sportId, "&startDate=").concat(startDate.toJSON(), "&endDate=").concat(endDate.toJSON()),
            method: 'get',
            types: [
                ActionTypes.SUCCESS_FETCH_SPORT_LINE_HEADERS,
                ActionTypes.FAILURE_FETCH_SPORT_LINE_HEADERS
            ],
            data: data
        },
        _a[TRANSFORM] = {
            section: 'preMatch',
            transformType: 'init',
            provider: function (data) { return data; }
        },
        _a;
}
export function getSportLineHeaders(data) {
    return function (dispatch) {
        return dispatch(fetchSportLineHeaders(data));
    };
}
function fetchLeagueLineHeaders(data) {
    var _a;
    var leagueId = data.leagueId, languageId = data.languageId;
    return _a = {
            type: ActionTypes.FETCH_LEAGUE_LINE_HEADERS
        },
        _a[CALL_API] = {
            endpoint: "/api/event/lines?languageId=".concat(languageId, "&leagueId=").concat(leagueId),
            method: 'get',
            types: [
                ActionTypes.SUCCESS_FETCH_LEAGUE_LINE_HEADERS,
                ActionTypes.FAILURE_FETCH_LEAGUE_LINE_HEADERS
            ],
            data: data
        },
        _a[TRANSFORM] = {
            section: 'preMatch',
            transformType: 'init',
            provider: function (data) { return data; }
        },
        _a;
}
export function getLeagueLineHeaders(data) {
    return function (dispatch) {
        return dispatch(fetchLeagueLineHeaders(data));
    };
}
function fetchFullLine(data) {
    var _a;
    var languageId = data.languageId, eventId = data.eventId;
    return _a = {
            type: ActionTypes.FETCH_FULL_LINE
        },
        _a[CALL_API] = {
            endpoint: "/api/event/".concat(eventId, "?languageId=").concat(languageId),
            method: 'get',
            types: [
                ActionTypes.SUCCESS_FETCH_FULL_LINE,
                ActionTypes.FAILURE_FETCH_FULL_LINE
            ],
            data: data
        },
        _a[TRANSFORM] = {
            section: 'preMatchEvent',
            transformType: 'init',
            provider: function (data) { return data; }
        },
        _a;
}
export function getFullLine(data) {
    return function (dispatch) {
        return dispatch(fetchFullLine(data));
    };
}
export function fetchPreMatchMenu(data) {
    var languageId = data.languageId;
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.FETCH_PREMATCH_MENU
            },
            _a[CALL_API] = {
                endpoint: "/api/menu?languageId=".concat(languageId, "&siteType=").concat(siteType),
                method: 'get',
                types: [
                    ActionTypes.SUCCESS_FETCH_PREMATCH_MENU,
                    ActionTypes.FAILURE_FETCH_PREMATCH_MENU
                ],
                data: data
            },
            _a[TRANSFORM] = {
                section: 'menu',
                transformType: 'init',
                provider: function (data) { return data; }
            },
            _a));
    };
}
export function clearLine() {
    return { type: ActionTypes.CLEAR_LINE, section: 'preMatch' };
}
function getFilterDateRange(filterType) {
    var startDate = new Date();
    var endDate;
    var year = startDate.getFullYear();
    var month = startDate.getMonth();
    var day = startDate.getDate();
    var hour = startDate.getHours();
    var minute = startDate.getMinutes();
    var second = startDate.getSeconds();
    switch (filterType) {
        case TimeFilter.HR1:
            endDate = new Date(year, month, day, hour + 1, minute, second);
            break;
        case TimeFilter.HR12:
            endDate = new Date(year, month, day, hour + 12, minute, second);
            break;
        case TimeFilter.HR24:
            endDate = new Date(year, month, day + 1, hour, minute, second);
            break;
        default:
            endDate = new Date(2999, 11, 31, 23, 59, 59);
    }
    return ({ startDate: startDate, endDate: endDate });
}



// WEBPACK FOOTER //
// ./src/actions/creators/lines.js